import React from "react";
import businessImg from "../assets/img/Business Reputation@2x@2x.png";
import newApproachImg from "../assets/img/New Approach@2x.png";
import "../assets/css/index.css";
import Hero from "./Hero";
import { Link, useNavigate } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";

const Assessments = () => {
  const navigate = useNavigate();
  return (
    <>
      <Header />
      <Hero />
      <section
        className="py-0 px-0 main-container1 d-flex justify-content-center"
        style={{ marginBottom: "15%" }}
      >
        <div>
          <div className="row  p-0 justify-content-center">
            {/* First Card */}
            <div className="col-md-6 col-xl-z">
              <div className="px-4">
                <div className="text-center mb-3">
                  <img
                    src={businessImg}
                    alt="Lock icon"
                    className="img-fluid"
                    style={{ minWidth: "397px", minHeight: "238px" }}
                  />
                </div>
                <h1 className="text-green text-start Asses-header1">
                  Secure by Design <br /> Foundation Assessment
                </h1>
                <p
                  className="mt-3 text-dark text-start info-text1"
                  style={{ maxWidth: "540px" }}
                >
                  This tool is for project Leaders. It helps them to measure
                  their teams' progress towards UK Ministry of Defence's Secure
                  by Design.
                </p>
                <a
                  href="https://sbd.bee-net.co.uk/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <button className="btn btn-purple-index mt-2">More</button>
                </a>
              </div>
            </div>

            {/* Second Card */}
            <div className="col-md-6 col-xl-6">
              <div className="px-4">
                <div className="text-center mb-3">
                  <img
                    src={newApproachImg}
                    alt="Assessment icon"
                    className="img-fluid"
                    style={{ minWidth: "397px", minHeight: "238px" }}
                  />
                </div>
                <h1 className="text-green text-start Asses-header1">
                  Cyber Security Management Maturity
                </h1>
                <p
                  className="mt-3 text-dark text-start info-text1"
                  style={{ maxWidth: "540px" }}
                >
                  This tool is for senior leadership teams. It helps them to
                  measure their organisational cyber security maturity and
                  preparedness and produce actionable management information.
                  <br />
                  <br />
                  It can also be more useful than traditional, technique due
                  diligence for portfolio inverstors as well as for procurement
                  managers looking to secure their supply chain from cyber
                  attacks.
                </p>
                <a
                  href="http://csmm.bee-net.co.uk/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <button className="btn btn-purple-index mt-2">More</button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default Assessments;
